import React from "react";
import { Table, Button, Typography } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import Moment from "moment";
import { extendMoment } from "moment-range";
import Employee from "../../../components/tables/Employee";
import Patient from "../../../components/tables/Patient";
import Date from "../../../components/tables/Date";
import { CloseOutlined } from "@ant-design/icons";
import ModalContentWrapper from "./ModalContentWrapper.style";
const moment = extendMoment(Moment);
const { Title, Text } = Typography;

const generateColumns = (intl) => {
  return [
    {
      title: intl.formatMessage({
        id: "app.plans.singleEventsEmployeeName",
      }),
      dataIndex: "employee",
      render(text, record) {
        return record.employee ? (
          <Employee record={record.employee} />
        ) : record.is_day_center ? (
          <Text>
            {intl.formatMessage({
              id: "app.scheduling.day_center",
            })}
          </Text>
        ) : null;
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.patientName",
      }),
      dataIndex: "order",
      render(text, record) {
        return record.order ? (
          <Patient record={record?.order?.patient} />
        ) : null;
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.clientName",
      }),
      dataIndex: "order",
      render(text, record) {
        return record?.order && <Text>{record?.order?.client?.name}</Text>;
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.weekday",
      }),
      dataIndex: "weekday",
      render(text) {
        return <Text>{moment.weekdays(text)}</Text>;
      },
      sortIndex: "weekday",
      sorter: (a, b) => a.weekday - b.weekday,
      defaultSortOrder: "ascend",
      sortDirections: ["ascend", "descend", "ascend"],
      width: "140px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.start_time",
      }),
      dataIndex: "start_time_minutes",
      render(text) {
        return (
          <Date
            text={moment().startOf("day").set("minute", text)}
            format={"HH:mm"}
          />
        );
      },
      width: "140px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.end_time",
      }),
      dataIndex: "end_time",
      render(text, record) {
        return (
          <Date
            text={moment()
              .startOf("day")
              .set(
                "minute",
                record.duration_minutes + record.start_time_minutes
              )}
            format={"HH:mm"}
          />
        );
      },
      width: "140px",
    },
  ];
};

const renderContinueButton = (allowedOverlapping, onContinue, intl) => {
  return allowedOverlapping ? (
    <>
      <Button type="primary" onClick={onContinue}>
        {intl.formatMessage({ id: "app.actions.createEvents" })}
      </Button>
      <div className="horizontal-divider" />
    </>
  ) : null;
};

const OverlappingEventsContent = (props) => {
  const { onMouseOver, onMouseOut, hide, handleContinue, allowedOverlapping } =
    props;
  const overlapped_events = useSelector(
    (state) => state.plan.activeSimulatedPlan.overlapped_recurrent_events
  );

  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);

  const intl = useIntl();
  const onContinue = () => {
    handleContinue();
    hide();
  };
  const columns = generateColumns(intl);

  return (
    <ModalContentWrapper direction={currentAppLocale.direction}>
      <div className="top" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <Button
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={hide}
        />
      </div>
      <div className="inner">
        <Title level={5}>
          {intl.formatMessage({
            id: allowedOverlapping
              ? "app.plans.overlappingEventsModalTitle"
              : "app.plans.notAllowedOverlappingModalTitle",
          })}
        </Title>

        <div style={{ width: "auto", maxWidth: "1200px" }}>
          <Table
            bordered
            dataSource={overlapped_events}
            columns={columns}
            pagination={false}
            scroll={{
              y: window.innerHeight / 2,
            }}
          />
        </div>
        <div className="vertical-divider" />
        <Text>
          {intl.formatMessage({
            id: allowedOverlapping
              ? "app.plans.overlappingEventsModalDescription"
              : "app.plans.notAllowedOverlappingModalDescription",
          })}
        </Text>
      </div>
      <div className="actions">
        {renderContinueButton(allowedOverlapping, onContinue, intl)}
        <Button onClick={hide}>
          {intl.formatMessage({ id: "app.actions.cancel" })}
        </Button>
      </div>
    </ModalContentWrapper>
  );
};

export default OverlappingEventsContent;
